























































import Vue from 'vue';

import { errorToMessage } from '@/core/utils/errors';
import { sanitize } from '@/core/utils/utils';

export default Vue.extend({
  data() {
    return {
      inProgress: false,
      user: null,
    };
  },
  methods: {
    sanitize,
    async getUserByUUID() {
      const uuid = this.$route.params.uuid;
      try {
        this.user = await this.$store.dispatch('user/getUserByUUID', uuid);
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: this.$t(
            'UNSUBSCRIBE.NOTIFICATIONS.FAILED_TO_LOAD_USER_WITH_THIS_TOKEN'
          ) as string,
          duration: -1,
        });
      }
    },
    async updateUserByUUID(emailsEnabled) {
      this.inProgress = true;
      if (this.user) this.user.emails_enabled = emailsEnabled;
      const uuid = this.$route.params.uuid;
      try {
        const data = { uuid, user: this.user };
        this.user = await this.$store.dispatch('user/updateUserByUUID', data);

        this.$notify({
          group: 'app',
          type: 'success',
          text: this.$t(
            'UNSUBSCRIBE.NOTIFICATIONS.EMAIL_SUBSCRIPTION_PREFERENCES'
          ) as string,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
      this.inProgress = false;
    },
  },
  computed: {
    userData() {
      return {
        user: this.user?.user_full_name,
        email: this.user?.user_email,
      };
    },
  },
  mounted() {
    this.getUserByUUID();
  },
});
